<template>
	<div>
		<div class="table-responsive">
			<div v-if="records.length > 0">
				<input type="text" placeholder="Search DNS records" class="form-control" v-model="search"/>
			</div>
			<table id="datatableDNS" class="table table-striped table-bordered text-center" style="border-spacing: 0; border: 0; width: 100%">
				<thead class="text-primary">
					<tr>
						<th>Type</th>
						<th>Name</th>
						<th style="width:25%">Value</th>
						<th>TTL</th>
						<th>Status</th>
						<th style="width: 8%; vertical-align: baseline;">
							<div class="custom-control custom-checkbox p mr-sm-2">
								<input type="checkbox" class="custom-control-input" @click="selectAll" v-model="allSelected" :disabled="loading" id="select_all"/>
								<label class="custom-control-label pt-1" for="select_all"></label>
							</div>
						</th>
						<th style="width: 20%">
							<button type="button" class="btn btn-outline-danger btn-round   pull-right btn-sm" :disabled="loading"
									@click="bulkRemove">
								<div class="loader small_loader" v-if="action === 'bulk-remove'"></div>
								<span v-else>
									<i class="fa fa-trash"></i>
							</span>
							</button>
							<button type="button" class="btn btn-outline-primary btn-round btn-sm " :disabled="loading"
									@click="bulkUpdate">
								<div class="loader small_loader" v-if="action === 'bulk-update'"></div>
								<i v-else class="fa fa-floppy-o"></i>
							</button>
						</th>
					</tr>
				</thead>
				<tbody>
        <template v-if="!loading">
          <tr v-for="record in filteredRecords" class="text-center">
            <td>
              <span>{{record.type}}</span>
            </td>
            <td>
              <span style="word-break: break-all;">{{record.name}}</span>
            </td>
            <td style="width:25%">
              <span style="word-break: break-all;">{{record.content}}</span>
            </td>
            <td>
							<span>
								<template v-if="record.ttl === 1">Automatic</template>
								<template v-else>{{record.ttl}}</template>
							</span>
            </td>
            <td class="text-center">
              <div class="custom-control custom-checkbox ml-2 d-flex justify-content-center">
                <!--<i v-if="record.proxied" class="fa fa-check-square text-success"></i>
                <i v-else class="fa fa-times text-danger"></i>-->
                <input type="checkbox" :id="'proxied_' + record.id" name="proxied" :disabled="loading" v-model="bulkEditRecords" :value="record.id" class="custom-control-input"/>
                <label class="custom-control-label" :for="'proxied_' + record.id"></label>
              </div>
            </td>
            <td class="text-center">
              <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
                <input type="checkbox" class="custom-control-input" :disabled="loading" name="identifiers" v-model="ids" :value="record.id" :id="'select_' + record.id"/>
                <label class="custom-control-label" :for="'select_' + record.id"></label>
              </div>
            </td>
            <td>
              <button type="button" class="btn btn-outline-danger btn-round  pull-right btn-sm" :disabled="loading" @click="remove(record)">
                <div class="loader small_loader" v-if="record.id === removeItem.id && action === 'remove'"></div>
                <i v-else class="fa fa-times"></i>
              </button>
              <button type="button" :disabled="loading" class="btn btn-outline-primary btn-round btn-sm" @click="edit(record)">
                <i class="fa fa-pencil"></i>
              </button>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="7">
              <div class="loader text-center"></div>
            </td>
          </tr>
        </template>
				</tbody>
			</table>

      <div v-if="!fromAlias" class="modal fade" id="editRecord" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="editRecord" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title d-inline">Edit {{editItem.type}} record</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="form-group row">
								<label class="col-sm-3 col-form-label">Type</label>
								<div class="col-sm-9">
									<select v-model="editItem.type" class="form-control" disabled>
										<option value="A">A</option>
										<option value="AAAA">AAAA</option>
										<option value="CNAME">CNAME</option>
										<option value="TXT">TXT</option>
										<option value="MX">MX</option>
									</select>
								</div>
							</div>
							<div class="form-group row">
								<label  class="col-sm-3 col-form-label">Name</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="editItem.name" :disabled="loading"/>
								</div>
							</div>
							<div class="form-group row">
								<label  class="col-sm-3 col-form-label">Value</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="editItem.content" :disabled="loading"/>
								</div>
							</div>
							<div class="form-group row">
								<label  class="col-sm-3 col-form-label">TTL</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="editItem.ttl" :disabled="loading"/>
								</div>
							</div>
							<div  v-if="editItem.type === 'MX'" class="form-group row">
								<label  class="col-sm-3 col-form-label">Priority</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="editItem.priority" :disabled="loading"/>
								</div>
							</div>
							<div class="form-group row">
								<label  class="col-sm-3 col-form-label">Status</label>
								<div class="col-sm-9">
									<div class="custom-control custom-checkbox" style="top: -5px;">
										<input type="checkbox" :id="'proxied_modal_' + editItem.id" value="1" name="proxied" :disabled="loading" v-model="editItem.proxied" class="custom-control-input"/>
										<label class="custom-control-label" :for="'proxied_modal_' + editItem.id"></label>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button type="button" class="btn btn-primary" @click.prevent="update">
								<div class="loader small_loader" v-if="action === 'update'"></div>
								<span v-else>Save</span>
							</button>
						</div>
					</div>
				</div>
			</div>

        </div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import _ from "lodash";
	import validateMethods from "../../../mixins/validateMethods";
	import refreshToken from "../../../mixins/refreshTokenMixin";

	export default {
		name: "DnsItems",
		props: [
			"account",
			"records",
			"loading",
      "fromAlias",
      "selectedAlias",
        "isTenant"
		],
		mixins: [validateMethods, refreshToken],
		data: function () {
			return {
				errors: [],
				editItem: {},
				removeItem: {},
				action: null,
				selected: [],
				bulkEditRecords: [],
				ids: [],
				allSelected: false,
				search: ''
			}
		},
		computed: {
			userToken() {
				return this.$store.getters.getUserToken;
			},
			filteredRecords() {
        console.log(this.records)
				const search = this.search.toLowerCase().trim();

				this.bulkEditRecords = _.map(_.filter(this.records, (item)=>{
					return item.proxied == true;
				}), 'id');

				if (!search) return this.records;

				return this.records.filter(c => c.name.toLowerCase().indexOf(search) > -1);
			}
		},
		methods: {
			selectAll: function () {
				this.ids = [];
				if (!this.allSelected) {
					for (let record in this.records) {
						this.ids.push(this.records[record].id);
					}
				}
			},
			edit(record) {
        if(this.fromAlias){
            this.$parent.editItem = Object.assign({}, record);
            this.$parent.openModal('editRecordAlias');
        }else{
            this.editItem = Object.assign({}, record);
            /* eslint-disable */
            $('#editRecord').modal('show');
            /* eslint-disable */
        }

			},
			update() {
			    console.log(this.fromAlias);
				this.action = 'update';
				this.errors = [];
				if (!this.editItem.name) {
					this.errors.push('Please fill DNS record name');
				}
				if (!this.editItem.content) {
					this.errors.push('Please fill DNS record content');
				}

				if (this.errors.length) {
					swal({
						title: "Error message!",
						html: this.errors.join('<br/>'),
						type: "error"
					});
					return false;
				}

				this.$emit('update-loading', true);
        let obj = {
          grant_type: "token",
          token: this.userToken,
          cloudflare_email: this.account.cloudflare.username,
          cloudflare_api_key: this.account.cloudflare.apiKey,
          cloudflare_zone: (this.fromAlias) ? this.selectedAlias.zoneId : this.account.cloudflare.zone_id,
          identifier: this.editItem.id,
          data: {
            type: this.editItem.type,
            name: this.editItem.name,
            content: this.editItem.content,
            ttl: parseInt(this.editItem.ttl),
            priority: parseInt(this.editItem.priority),
            proxied: this.editItem.proxied
          }
        }
        if(this.isTenant){
          obj.isTenant = true
        }

				this.$http.post("dns/update", )
					.then(() => {
						this.$emit('update-list');
						this.cancel();
						/* eslint-disable */
						$('#editRecord').modal('hide');
						/* eslint-disable */
						swal({
							title: "Message!",
							html: "You have successfully updated the DNS record.",
							type: "success",
							confirmButtonText: "OK!",
							confirmButtonColor: "#EE8057"
						});
						this.$emit('update-loading', false);
						this.action = null;
						if(this.fromAlias){
						    this.$parent.action = null;
            }
					})
					.catch((err) => {
						const {response} = err;
						let responseMessage = response.data.message;
						if (response.status === 422) {
							responseMessage = _.map(response.data.errors, 'msg').join('. ')
						} else if (response.status === 401) {
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}
						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						if (response.status !== 401) {
							this.addLog({
								name: this.user.firstName + " " + this.user.lastName,
								message: "Error update DNS record. Message: " + responseMessage,
								level: "danger"
							});
						}
						this.$emit('update-loading', false);
						this.action = null;
                        if(this.fromAlias){
                            this.$parent.action = null;
                        }
					});
			},
			remove(record) {
				this.removeItem = record;
				swal({
					title: "Are you sure?",
					text: `Are you sure you want to delete this redirect?`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.action = 'remove';

							this.$emit('update-loading', true);
              let obj = {
                grant_type: "token",
                token: this.userToken,
                cloudflare_email: this.account.cloudflare.username,
                cloudflare_api_key: this.account.cloudflare.apiKey,
                cloudflare_zone: (this.fromAlias) ? this.selectedAlias.zoneId : this.account.cloudflare.zone_id,
                identifier: record.id
              }
              if(this.isTenant) {
                obj.isTenant = true
              }

							this.$http.post("dns/delete", obj )
								.then(() => {
									this.$emit('update-list');
									this.cancel();
									swal({
										title: "Message!",
										html: "You successfully deleted DNS record",
										type: "success",
										confirmButtonText: "OK!",
										confirmButtonColor: "#EE8057"
									});
									this.$emit('update-loading', false);
									this.action = null;
								})
								.catch((err) => {
									const {response} = err;
									let responseMessage = response.data.message;
									if (response.status === 422) {
										responseMessage = _.map(response.data.errors, 'msg').join('. ')
									} else if (response.status === 401) {
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}
									this.$emit('update-loading', false);
									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									});
									if (response.status !== 401) {
										this.addLog({
											name: this.user.firstName + " " + this.user.lastName,
											message: "Error delete DNS record. Message: " + responseMessage,
											level: "danger"
										});
									}
									this.$emit('update-loading', false);
									this.action = null;
								});
						}
					});
			},
			bulkUpdate() {

				let results = [];
				_.map(this.bulkEditRecords, (item) => {
					const existingItem = _.find(this.records, (obj) => {
						return item === obj.id;
					});
					results.push({
						id: existingItem.id,
						type: existingItem.type,
						name: existingItem.name,
						content: existingItem.content,
						proxied: true
					});
					existingItem.proxied = true;

				});
				_.map(this.records, (item)=>{
					let checked = this.bulkEditRecords.indexOf(item.id) !== -1;
					if(!checked && item.proxied === true){
						results.push({
							id: item.id,
							type: item.type,
							name: item.name,
							content: item.content,
							proxied: !item.proxied
						});
						item.proxied = false;
					}
				});
				if (this.ids.length) {
					console.log('update all...');
					_.map(this.records, (item)=>{
						results.push({
							id: item.id,
							type: item.type,
							name: item.name,
							content: item.content,
							proxied: true
						});
						item.proxied = true;
					});
				}
				console.log(results);
				if (!results.length) {
					swal({
						title: "Something went wrong!",
						html: "Please select DNS records",
						type: "error",
						confirmButtonText: "OK!",
						confirmButtonColor: "#EE8057"
					});
					return false;
				}
				this.action = "bulk-update";
				this.$http.post('dns/bulk-update', {
					grant_type: "token",
					token: this.userToken,
					domain: this.account.domain,
					cloudflare_email: this.account.cloudflare.username,
					cloudflare_api_key: this.account.cloudflare.apiKey,
					cloudflare_zone: (this.fromAlias) ? this.selectedAlias.zoneId : this.account.cloudflare.zone_id,
					data: results
				})
					.then(() => {
						swal({
							title: "Message!",
							html: "You successfully updated DNS records",
							type: "success",
							confirmButtonText: "OK!",
							confirmButtonColor: "#EE8057"
						});
						this.ids = [];
						this.selected = [];
						this.allSelected = false;
						this.$emit('update-loading', false);
						this.action = null;
					})
					.catch((err) => {
						const {response} = err;
						let responseMessage = response.data.message;
						if (response.status === 422) {
							responseMessage = _.map(response.data.errors, 'msg').join('. ')
						} else if (response.status === 401) {
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}
						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						if (response.status !== 401) {
							this.addLog({
								name: this.user.firstName + " " + this.user.lastName,
								message: "Error update dns. Message: " + responseMessage,
								level: "danger"
							});
						}
						this.$emit('update-loading', false);
						this.action = null;
					});
			},
			bulkRemove() {
				if (!this.ids.length) {
					swal({
						title: "Something went wrong!",
						html: "Please select DNS records",
						type: "error",
						confirmButtonText: "OK!",
						confirmButtonColor: "#EE8057"
					});
					return false;
				}
				swal({
					title: "Are you sure?",
					text: `Are you sure you want to delete this records?`,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(result => {
						if (result.value) {
							this.action = "bulk-remove";
							this.$http.post('dns/bulk-delete', {
								grant_type: "token",
								token: this.userToken,
								domain: this.account.domain,
								cloudflare_email: this.account.cloudflare.username,
								cloudflare_api_key: this.account.cloudflare.apiKey,
								cloudflare_zone: (this.fromAlias) ? this.selectedAlias.zoneId : this.account.cloudflare.zone_id,
								identifiers: this.ids
							})
								.then(() => {
									this.$emit('update-list');
									swal({
										title: "Removed!",
										html: "You've successfully removed the selected DNS records",
										type: "success",
										confirmButtonText: "OK!",
										confirmButtonColor: "#EE8057"
									});
									this.$emit('update-loading', false);
									this.action = null;
									this.selected = [];
									this.ids = [];
									this.allSelected = false;
								})
								.catch((err) => {
									const {response} = err;
									let responseMessage = response.data.message;
									if (response.status === 422) {
										responseMessage = _.map(response.data.errors, 'msg').join('. ')
									} else if (response.status === 401) {
										responseMessage = "You need update token. Please Try Again!";
										this.refreshToken();
									}
									this.$emit('update-loading', false);
									this.action = null;
									swal({
										title: "Something went wrong!",
										html: responseMessage,
										type: "error",
										confirmButtonText: "Try Again!",
										confirmButtonColor: "#EE8057"
									});
									if (response.status !== 401) {
										this.addLog({
											name: this.user.firstName + " " + this.user.lastName,
											message: "Error delete dns. Message: " + responseMessage,
											level: "danger"
										});
									}
								});
						}
					});
			},
			cancel() {
				this.editItem = {};
				this.action = null;
				this.removeItem = {};
			}
		},
		mounted() {
			/* eslint-disable */
			$(document).ready(function() {
				$("#datatableDNS").DataTable({
					'bSort': false,
					"pageLength": 100,
					responsive: true,
          destroy: true,
          retrieve: true,
					"info" : false,
					bFilter: false,
					bInfo: false,
					"bLengthChange": false,
					"ordering" : false,
				});
			});
			/* eslint-enable */
		}
	}
</script>

<style>
	.loader.small_loader {
		width: 15px;
		height: 15px;
	}

	.item-type {
		width: 75px;
	}

	.item-to {
		width: calc(100% - 75px);
	}

	.table th {
		font-weight: normal;
	}
</style>
